import { handleApiResponse } from './api.utils';
import API_CONFIG from '../../config/api.config';
import apiClient from './apiClient';

interface Task {
  idTask: number;
  createdByUser: number;
  assignedToUser: number | null;
  assignedToRole: number | null;
  idProduct: number;
  barcode: string;
  status: TaskStatus;
  createdDate: string;
  updatedDate: string;
}

type TaskStatus = 'new' | 'in_progress' | 'started' | 'completed' | 'deleted' | 'cancelled';

interface CreateTaskResponse {
  status: string;
  taskId?: number;
  message?: string;
}

interface CreateTaskParams {
  productId: number;
  assignedToUser?: number;
  assignedToRole?: number;
  status?: TaskStatus;
  quantity?: number;
}

interface UpdateTaskParams {
  status?: TaskStatus;
  sourceLocation?: number;  // idMPSL from map_product_stock_locations
  targetDestinationidWarehouseArea?: number;  // idWarehouseArea from warehouse_areas
  targetDestinationName?: string; // for non-warehouse consumption destinations
  explanation?: string; // optional description for internal use
  quantity?: number;
  assignedToUser?: number;
}

interface UpdateTaskResponse {
  status: string;
  message?: string;
}

interface CancelTaskResponse {
  status: string;
  message?: string;
}

interface CompleteTaskResponse {
  status: string;
  message?: string;
}

class TaskService {
  private static instance: TaskService;

  private constructor() {}

  public static getInstance(): TaskService {
    if (!TaskService.instance) {
      TaskService.instance = new TaskService();
    }
    return TaskService.instance;
  }

  public async createTask(params: CreateTaskParams): Promise<CreateTaskResponse> {
    try {
      return await apiClient.post('/stoc/async/tasks', {
        productId: params.productId,
        assignedToUser: params.assignedToUser || null,
        assignedToRole: params.assignedToRole || null,
        quantity: params.quantity || 1,
        status: params.status || 'new'
      });
    } catch (error) {
      console.error('Failed to create task:', error);
      throw error;
    }
  }

  public async updateTask(taskId: number, params: UpdateTaskParams): Promise<UpdateTaskResponse> {
    try {
      return await apiClient.put(`/stoc/async/tasks/${taskId}`, {
        status: params.status,
        sourceLocation: params.sourceLocation,
        targetDestinationidWarehouseArea: params.targetDestinationidWarehouseArea,
        targetDestinationName: params.targetDestinationName,
        explanation: params.explanation,
        quantity: params.quantity,
        assignedToUser: params.assignedToUser
      });
    } catch (error) {
      console.error('Failed to update task:', error);
      throw error;
    }
  }

  public async cancelTask(taskId: number): Promise<CancelTaskResponse> {
    try {
      return await apiClient.post(`/stoc/async/tasks/${taskId}/cancel`, {});
    } catch (error) {
      console.error('Failed to cancel task:', error);
      throw error;
    }
  }
}

export default TaskService.getInstance(); 